@if ((isUserLoggedIn$ | async) === false) {
<div class="mobi-ui-link-block-major">
  <button
    class="mobi-ui-btn-minor"
    data-test-id="azureAdLoginButton"
    (click)="loginWithAzureAd()"
  >
    Login CIP
  </button>
</div>
} @else {
<div class="mobi-ui-link-block-major">
  <app-test-user-selection />
  <button class="mobi-ui-btn-minor mobi-ui-margin-l-md" (click)="logout()">
    Logout
  </button>
</div>
}
